<template lang="">
  <div class="appointementCreator">
    <v-card>
      <div class=" d-flex flex-column justify-space-around pa-8 appointementCreator__text" flat>
        <h4 class="appointementCreator__title">
          {{ title }}
        </h4>
        <div class="d-flex flex-row justify-space-between  align-center  mt-7">
          <span v-if="appointmentOptician" class="appointementCreator__text-paragraph">
            {{ appointmentOptician.title }}
          </span>
          <span v-if="appointmentOptician && appointmentUser" class="appointementCreator__text-paragraph">
            /
          </span>
          <span v-if="appointmentUser" class="appointementCreator__text-paragraph">
            {{ appointmentUser.title }}
          </span>
          <div class="d-flex flex-row appointementBar mx-11">
            <v-tooltip v-if="appointmentOptician" bottom>
              <template v-slot:activator="{ on: activationEvents, attrs }">
                <div
                  class="appointementBar__Optician mr-1"
                  v-on="activationEvents"
                  :style="{
                    width: appointmentOptician.percentage + '%'
                  }"
                  :class="{
                    appointementBar__Optician_variant: attrs['aria-expanded'] === 'true'
                  }"
                ></div>
              </template>
              <span class="mr-8"> {{ appointmentOptician.title }} </span>
              <span> {{ appointmentOptician.percentage + '%' }} </span>
            </v-tooltip>
            <v-tooltip v-if="appointmentUser" bottom>
              <template v-slot:activator="{ on: activationEvents, attrs }">
                <div
                  class="appointementBar__user"
                  v-on="activationEvents"
                  :style="{
                    width: appointmentUser.percentage + '%'
                  }"
                  :class="{
                    appointementBar__user_variant: attrs['aria-expanded'] === 'true'
                  }"
                ></div>
              </template>
              <span class="mr-8"> {{ appointmentUser.value + " " + appointmentUser.title }} </span>
              <span> {{ appointmentUser.percentage + '%' }} </span>
            </v-tooltip>
          </div>
          <span v-if="appointmentOptician" class="appointementCreator__text-paragraph">
            {{ appointmentOptician.percentage + '%' }}</span
          >
          <span v-if="appointmentOptician && appointmentUser" class="appointementCreator__text-paragraph"> /</span>
          <span v-if="appointmentUser" class="appointementCreator__text-paragraph">
            {{ appointmentUser.percentage + '%' }}</span
          >
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { division } from '@/services/sorter'

export default {
  name: 'AppointmentCreator',
  props: {
    title: String,
    total: Number,
    appointmentCreators: {
      type: Array
    }
  },
  data() {
    return {
      hoverAppointment: false
    }
  },
  computed: {
    appointmentOptician: function() {
      return this.appointmentCreators.phone_shop !== 0
        ? {
            title: this.$t('optician.plural'),
            percentage: division(this.appointmentCreators.phone_shop * 100, this.total)
          }
        : null
    },
    appointmentUser: function() {
      return this.appointmentCreators.consumer !== 0
        ? {
            title: this.$t('user.plural'),
            value: this.appointmentCreators.consumer,
            percentage: division(this.appointmentCreators.consumer * 100, this.total)
          }
        : null
    }
  }
}
</script>
<style scoped lang="scss">
.appointementCreator__text {
  color: var(--v-text-base);
}
.appointementCreator__title {
  font-size: 18px;
}
.appointementCreator__text-paragraph {
  font-size: 14px;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: -0.011em;
}
.appointementBar {
  width: 100%;
  height: 24px;
  border: 1px solid transparent;
  margin: 1rem 0;
  border-radius: 2px;
}

.appointementBar__empty {
  background: #f2f4f6;
}
.appointementBar__Optician {
  background: #454c5e;
}
.appointementBar__Optician_variant {
  border: 3px solid rgba(242, 244, 246, 0.51);
  box-sizing: border-box;
  height: 36px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.appointementBar__user {
  background: #1463bd;
}
.appointementBar__user_variant {
  border: 3px solid rgba(242, 244, 246, 0.51);
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  height: 36px;
}

.v-tooltip__content {
  background: rgba(69, 76, 94, 0.23);
  border: 1px solid #536da8;
  box-sizing: border-box;
  border-radius: 2px;
  color: var(--v-secondary-base);
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 24px;
}
</style>
